import React from "react";
import { CruiseProvider } from "../context/CruiseContext";
import escape from "../data/escape";
import SiteLayout from "../components/SiteLayout";

const Escape = () => (
  <CruiseProvider cruise={escape}>
    <SiteLayout />
  </CruiseProvider>
);

export default Escape;
